import { CaseApplicantModel } from 'app/edozvola/cases/case-applicant/model/case-applicant.model';
import axios from 'axios';
import { CodebookModel } from 'app/shared/model/shared.model';

export const saveApplicant = async (idCase: string, applicant: CaseApplicantModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/applicant/${idCase}`, applicant)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchApplicants = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/applicant/find-all/${idCase}?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};

export const getCaseApplicant = async (idCaseApplicant: string): Promise<CaseApplicantModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/applicant/${idCaseApplicant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const findAssigneeNamesLinkedToSelectedApplicant = async (idCaseApplicant: string): Promise<string> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/applicant/assignees-linked-to-selected-applicant/${idCaseApplicant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const fetchApplicantsForAssignee = async (idCase: string, idApplicant: string): Promise<CodebookModel[]> => {
  let url = `api/applicant/assignee-applicant/${idCase}`;

  if (idApplicant) {
    url =  `api/applicant/assignee-applicant/${ idCase }?idApplicant=${ idApplicant }`;
  }

  return await new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const deleteApplicant = async (idApplicant: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/applicant/${idApplicant}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const createEGradaninInitialData = async (idUser: number): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/applicant/create-initial-form/${idUser}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const copyApplicants = async (caseUuid: string, caseUuidToCopyFrom: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/applicant/copy/${caseUuid}/${caseUuidToCopyFrom}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getApplicantsNumber = async (caseUuid: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/applicants-number`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveApplicantsNumber = async (caseUuid: string, applicantsNumber: CodebookModel[]): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${caseUuid}/applicants-number`, applicantsNumber)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const getApplicantsVariant = async (caseUuid: string, caseInPreview: boolean): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/applicant-variant?caseInPreview=${caseInPreview}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
